import React from 'react'
import './spinner.css'

interface ISpinnerProps {
  dark?: number
}

export const Spinner = (props: ISpinnerProps) => {
  return (
    <div {...props} className={props.dark ? `loader loader-dark` : `loader`}>
      Loading...
    </div>
  )
}
